import { useI18n, formatDate } from '../../i18n';
import { UserPlusIcon } from '../shared/Icons';

interface RegistrationPanelProps {
  /** `tournaments.registration_deadline`, an instant. Information only: the
   *  server does not refuse a registration after it; the locks do that. */
  deadline: string | null;
  /** The number of registrations of the tournament. */
  registered: number;
  /** Absent when the viewer cannot register: the panel then shows the facts only. */
  onRegister?: () => void;
}

// The registration panel (operator, 2026-09-25). While registration is open,
// one card between the header and the tabs holds the deadline, the number of
// registered boxers and the Register Boxers button. The button was a small
// header button beside the three lock switches, and it looked like one of them.
export default function RegistrationPanel({ deadline, registered, onRegister }: RegistrationPanelProps) {
  const { t } = useI18n();
  const passed = deadline !== null && new Date(deadline).getTime() < Date.now();
  const when = deadline ? formatDate(new Date(deadline), 'EEE d MMM, HH:mm') : null;
  return (
    <div data-testid="registration-panel"
      className="no-print rounded-xl border border-green-200 bg-green-50 p-4 flex flex-wrap items-center gap-x-4 gap-y-3">
      <div className="flex-1 basis-56 min-w-0">
        <div className="font-bold text-green-800">{t.tournament.registrationOpen}</div>
        <div data-testid="registration-panel-count" className="text-sm text-green-700 mt-0.5">
          {when && (
            <span data-testid="registration-panel-deadline" className={passed ? 'font-semibold text-amber-700' : undefined}>
              {(passed ? t.tournament.registrationDeadlinePassed : t.tournament.registrationCloses).replace('{date}', when)}
              {' · '}
            </span>
          )}
          {t.tournament.registeredBoxers.replace('{n}', String(registered))}
        </div>
      </div>
      {onRegister && (
        <button onClick={onRegister} data-testid="registration-panel-register"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 min-h-12 px-5 rounded-lg bg-green-600 hover:bg-green-700 text-white font-bold shadow-md transition-colors">
          <UserPlusIcon />
          {t.tournament.registerBoxers}
        </button>
      )}
    </div>
  );
}
